import { UUID, ID } from "./common.types";

// User types based on backend entity and frontend usage
export enum UserType {
    GUEST = "guest",
    REGISTERED = "registered",
    ADMIN = "admin",
    EDITOR = "editor",
    AGENT = "agent",
}

export interface NotificationSetting {
    id: UUID;
    type: string;
    enabled: boolean;
    userId: UUID;
}

export interface LeaderboardTab {
    tab: number;
    button: number;
}

export interface ChallengeHistoryUser {
    id: UUID | null;
    nickname: string;
}

export interface User {
    id: UUID;
    first_name: string;
    last_name: string;
    emailAddress: string;
    nickname: string;
    type?: UserType;
    isPro: boolean;
    showStartupModal: boolean;
    showScoreLeaderboard: boolean;
    notifyDailyProperty: boolean;
    notification_settings: NotificationSetting[];
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    is_created: boolean;
    user_retrieve_error: boolean;
    currentAreaId: UUID | string;
    currentLocation: string;
    currentLocationLat?: number;
    currentLocationLng?: number;
    show_scrollability_tooltip: boolean;
    useEmailAccountPicture: boolean;
    challengeHistorySelectedUser: ChallengeHistoryUser;
    leaderboard_active_tab: LeaderboardTab;
    guest_challenge_redirect: string;
    challenge_register_button: string;
    guest_final_score_modal_version: string;
    leaderboardSelectedVersion: string;
    onboardingTimestamp?: Date;
    lastVisitedAt?: Date;
    inactiveEmailSent?: boolean;
    lastPropertyNotificationAt?: Date;
    bio?: string | null;
    profilePhotoUrl?: string | null;
    displayName?: string | null;
    profilePrivate?: boolean;
}

// User context types
export interface UserContextType {
    userState: User;
    isInvalidLogin: boolean;
    hasFetchedData: boolean;
    isLoading: boolean;
    // Supports both signatures:
    // - setUserState(user: User): void
    // - setUserState(user: User | null, isUserCreated: boolean, otherProps?: Partial<User>): void
    setUserState: (user: User | null, isUserCreated?: boolean, otherProps?: Partial<User>) => void;
    clearUserState: () => void;
    setInvalidLogin: (invalid: boolean) => void;
    fetchUserData: (userId: ID) => Promise<void>;
    updateGuestCurrentArea: (areaId: UUID) => void;
}

// Auth0 user type (from @auth0/auth0-react)
export interface Auth0User {
    email?: string;
    email_verified?: boolean;
    family_name?: string;
    given_name?: string;
    locale?: string;
    name?: string;
    nickname?: string;
    picture?: string;
    sub?: string;
    updated_at?: string;
}

export interface FormattedAuthUser {
    email?: string;
    emailVerified?: boolean;
    name?: string;
    nickname?: string;
    picture?: string;
    sub?: string;
    updatedAt?: string;
    version: string;
    onboardingTimestamp: string;
    currentAreaId: string | null;
    givenName?: string;
    familyName?: string;
}
